<svelte:options tag={null} />

<script lang="ts">
  export let name: string;
  export let value: string;
  export let placeholder: string;
  export let rows = 3;
  export let isvalid: boolean;
  export let isinvalid: boolean;
  export let disabled = false;
  export let minlength: number;
  export let maxlength: number;

  $: userClass = $$props.class;
  $: attributes = { ...$$restProps };
  $: delete attributes.class;

  function getClasses(isValid: boolean, isInvalid: boolean): string {
    const classes = ['mc-textarea'];

    if (isValid) {
      classes.push('is-valid');
    }

    if (isInvalid) {
      classes.push('is-invalid');
    }

    return classes.join(' ');
  }
</script>

<textarea
  bind:value
  class="{getClasses(isvalid, isinvalid)} {userClass}"
  aria-invalid={isinvalid}
  {name}
  id={name}
  {placeholder}
  {rows}
  {disabled}
  {minlength}
  {maxlength}
  spellcheck="false"
  {...attributes}
/>

<style lang="scss">
  @import '@mozaic-ds/styles/settings-tools/_all-settings';
  @import '@mozaic-ds/styles/components/c.textarea';
  @import '@mozaic-ds/styles/components/c.fields';
</style>
